module.exports = __webpack_public_path__ + "static/media/work.dee861aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/work.svg
// module id = 94
// module chunks = 0